import { useAppSelector } from 'hooks';

export const useSettings = () => {
  const data = useAppSelector((state) => state.settings);

  return data;
};
